<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    // metaInfo: {
    //   meta: [
    //     { name: 'robots', content: process.env.NUXT_ENV_NOFOLLOW || 'noindex, nofollow' }, // not working without browser JS
    //   ]
    // },
  }
</script>

<style>
html {
	scroll-behavior: smooth;
}
#app p{
  @apply mb-6;
  @apply text-left;
  @screen lg{
    @apply text-justify;
  }
}
#app p:last-child{
  @apply mb-0;
}
#app .footer{
  @apply text-right;
  @screen sm{
    @apply text-left;
  }
}
#app .center{
  @apply text-center;
}
#app {
	font-family: Montserrat, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	@apply text-base;
  @apply text-black;
  @apply font-light;
  @apply leading-relaxed;
	@screen lg {
		@apply text-lg;
	}
}
.container {
	@apply mx-auto;
}

</style>

